var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monitor-page",attrs:{"id":"videoMaincontent2"}},[_c('div',{ref:"affair",style:({ width: _vm.swfWidth + 'px', height: _vm.swfHeight + 'px' }),attrs:{"id":"playWndMap"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }